import { Typography, Stack, Icon, Paper, IconButton } from '@ace-clublabs/shared-component-library';
import { PriceInfoCard } from './PriceInfoCard';

export interface AddedInfoCardProps {
  title?: JSX.Element | string;
  subtitle?: string;
  content?: JSX.Element | string;
  editButtonOnClick?: () => void;
  deleteButtonOnClick?: () => void;
  isFree?: boolean;
  hasDiscount?: boolean;
  originalPrice?: number;
  priceAfterDiscount?: number;
  priceSuffix?: string;
  className?: string;
}

export const AddedInfoCard = ({
  title,
  subtitle,
  content,
  editButtonOnClick,
  deleteButtonOnClick,
  originalPrice,
  priceAfterDiscount,
  priceSuffix,
  className,
}: AddedInfoCardProps) => {
  const showPriceOnFirstLine = !editButtonOnClick && !deleteButtonOnClick;

  return (
    <Paper
      sx={{
        marginTop: '1rem',
        padding: '1rem',
        borderRadius: '0.5rem',
        boxShadow: '0 -2px 1px 0 rgba(8, 17, 34, 0.04), 0 2px 4px 0 rgba(8, 17, 34, 0.20)',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        padding={title !== undefined ? '0.5rem 0' : '0'}
      >
        <Typography variant="b1Medium" className={`${className}-title`}>
          {title}
        </Typography>
        <Stack direction="row" alignItems="center" sx={{ gap: '0.5rem' }}>
          {editButtonOnClick && (
            <IconButton
              aria-label={'edit-item'}
              onClick={editButtonOnClick}
              className={`${className}-edit-button`}
              sx={{ padding: '1rem', height: '24px', width: '24px', color: '#0156A3' }}
            >
              <Icon iconName="pen-regular" />
            </IconButton>
          )}
          {deleteButtonOnClick && (
            <IconButton
              aria-label={'remove-item'}
              onClick={deleteButtonOnClick}
              className={`${className}-delete-button`}
              sx={{ padding: '1rem', height: '24px', width: '24px', color: '#0156A3' }}
            >
              <Icon iconName="xmark-regular" />
            </IconButton>
          )}
        </Stack>
        {showPriceOnFirstLine && (
          <PriceInfoCard
            originalPrice={originalPrice}
            priceAfterDiscount={priceAfterDiscount}
            priceSuffix={priceSuffix}
            className={className}
          />
        )}
      </Stack>

      <Stack
        direction="row"
        alignItems={subtitle !== undefined ? 'flex-start' : 'center'}
        justifyContent="space-between"
        gap="0.5rem"
      >
        <Stack direction="column">
          {subtitle && (
            <Typography
              variant="b1Regular"
              className={`${className}-subtitle qm-mask`}
              data-di-mask="true"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              {subtitle}
            </Typography>
          )}
          <Typography variant="b3Regular" className={`${className}-content`}>
            {content}
          </Typography>
        </Stack>
        {!showPriceOnFirstLine && (
          <PriceInfoCard
            originalPrice={originalPrice}
            priceAfterDiscount={priceAfterDiscount}
            priceSuffix={priceSuffix}
            className={className}
          />
        )}
      </Stack>
    </Paper>
  );
};
